import {
  SET_CLASS_PRO_STATUS,
  SET_CLASS_PRO_SCHOOL,
  SET_CLASS_PRO_LEVEL,
  SET_CLASS_PRO_FACULT,
  SET_CLASS_PRO_USER
} from '@/store/mutation-types'

export default {
  [SET_CLASS_PRO_STATUS] (state, payload) {
    state.searchClassProStatus = payload
  },
  [SET_CLASS_PRO_SCHOOL] (state, payload) {
    state.searchClassProSchool = payload
  },
  [SET_CLASS_PRO_LEVEL] (state, payload) {
    state.searchClassProLevel = payload
  },
  [SET_CLASS_PRO_FACULT] (state, payload) {
    state.searchClassProFacult = payload
  },
  [SET_CLASS_PRO_USER] (state, payload) {
    state.searchClassProUser = payload
  },
}



// WEBPACK FOOTER //
// ./src/components/class-pros/store/mutations.js